// Style
import './ChatDashboard.scss'

// React and Third Party
import { useEffect } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import {
  KEY_CHAT_TYPE,
  ROUTE_CHAT,
  ROUTE_CHAT_GENERAL,
  ROUTE_TODAY
} from 'components/common/helpers/Paths'
import { getAuthenticatedUser } from 'components/auth'
import { generativeFeatures } from 'components/common/api/constants'
import { navigateTo } from 'components/common/navigation'
import { buildRequestURL } from 'components/common/api'

import RembleAvatar from '../../../assets/images/Remble_Logomark-Green-25pGreen.png'

/**
 * Core Chat Dashboard Component
 * @returns {JSX.Element} The Chat Dashboard Component
 */
export default function ChatDashboard({ setHeaderTitle, setReturnPath }) {
  const user = getAuthenticatedUser()
  const history = useHistory()
  const features = generativeFeatures

  /**
   * Handle clicking on a feature
   * @param {Object} feature The feature
   */
  const handleFeatureClick = async feature => {
    const uri = ROUTE_CHAT.replace(`:${KEY_CHAT_TYPE}`, feature.slug)
    const url = buildRequestURL(uri, { returnPath: ROUTE_CHAT_GENERAL })

    // Navigate to the feature
    navigateTo(url, history)
  }

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0)

    // Set the header title
    setHeaderTitle('Mia User Guide')
    setReturnPath(ROUTE_TODAY)
  }, [setHeaderTitle, setReturnPath])

  return (
    <Container className='container-dashboard'>
      <h1 className='mb-0 title'>
        <img
          src={RembleAvatar}
          alt=''
          width='30'
          style={{ position: 'relative', top: '-4px' }}
        />{' '}
        Hello
        {user?.display_name ? `, ${user.display_name}` : ', there'}
      </h1>
      <h4 className='subtitle muted mt-5 mb-3'>What would you like to do?</h4>
      <Row className='dashboard-features mb-5'>
        {features.map(feature => (
          <Col sm={12} md={6} key={feature.slug}>
            <Card onClick={_ => handleFeatureClick(feature)}>
              <Card.Body>
                <Card.Title>
                  <i className={`bi bi-${feature.icon}`} /> {feature.title}
                </Card.Title>
                <Card.Text>{feature.subtitle}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  )
}
